import type { Doc } from "../../../_generated/dataModel";
import type { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";

// Filtra conteos físicos por estado con aislamiento por empresa.
export const inventoryCountStatusRule: FilterRule<Doc<"inventory_counts">> = {
  priority: 2,
  build: async (ctx: FilterRuleCtx, args) => {
    const status = (
      args as Partial<Doc<"inventory_counts">> & { status?: string }
    ).status;
    if (!status) return undefined;
    return await ctx.db
      .query("inventory_counts")
      .withIndex("by_company_and_status", (q) =>
        q
          .eq("internalControl.companyId", ctx.userContext.companyId)
          .eq("status", status as Doc<"inventory_counts">["status"]),
      )
      .collect();
  },
};
